module.exports = __webpack_public_path__ + "static/media/timer.8213d00a.svg";